import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

import dashboard from './routes/dashboard'


import users from './routes/users'
import blog from './routes/blog'
import portfolio from './routes/portfolio'
import service from './routes/service'

import publications from './routes/publications'
import banner from './routes/banner'
import navigation  from './routes/navigation'
import groups from './routes/groups'

import promotions from './routes/promotions'
import vouchers from './routes/vouchers'

import settings from './routes/settings'
import widgets from './routes/widgets'
//import feedback from './routes/feedback'
import pages from './routes/pages'
import comment from './routes/comment'
import component from './routes/component'
import files from './routes/files'
import languages from './routes/languages'
import products from './routes/products'
import socials from './routes/socials'
import sites from './routes/sites'
import food from './routes/food'
import rooms from './routes/rooms'
import guides from './routes/guides'
import eat from './routes/eat'
import facility from './routes/facility'
import offers from './routes/offers'
import meetingAndEvents from './routes/meetingAndEvents'
import reviews from './routes/reviews'
import mediaGallery from './routes/mediaGallery'
import awards from './routes/awards'
import packages from './routes/packages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
   // { path: '/', redirect: { name: 'dashboard-analytics' } },
   { path: '/', redirect: { name: 'dashboard-coparate' } },
    ...dashboard,

    ...users,
    ...blog,
    ...portfolio,
    ...service,
    ...publications,
    ...promotions,
    ...vouchers,
    ...banner,
    ...navigation,
    ...component,
    ...groups,
    ...widgets,
    ...settings,
    //...feedback,
    ...languages,
    ...pages,
    ...comment,
    ...files,
    ...products,
    ...socials,
    ...sites,
    ...food,
    ...rooms,
    ...packages,
    ...guides,
    ...eat,
    ...facility,
    ...offers,
    ...meetingAndEvents,
    ...reviews,
    ...mediaGallery,
    ...awards,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
